/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";

import type { SignInState } from "../signIn.types";
import { generateQrCodeBitmap } from "../thunks/qrCode.thunks";

/**
 * Reducers for the QR code rendered from the license-plate binding URL.
 */
export function registerQrCodeReducers(
  builder: ActionReducerMapBuilder<SignInState>
): void {
  builder.addCase(generateQrCodeBitmap.pending, (state) => {
    state.qrCodeBitmap = "";
  });
  builder.addCase(generateQrCodeBitmap.fulfilled, (state, action) => {
    state.qrCodeBitmap = action.payload;
  });
  builder.addCase(generateQrCodeBitmap.rejected, (state) => {
    state.qrCodeBitmap = "";
  });
}
